module.exports = __webpack_public_path__ + "static/media/hero-home.130ace8b.svg";